import { render } from "./AmeliaPascoaLayout.vue?vue&type=template&id=01bcbec9&ts=true"
import script from "./AmeliaPascoaLayout.vue?vue&type=script&lang=ts"
export * from "./AmeliaPascoaLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__